<template>
   <v-toolbar :fixed="!modalMode" :style="{'padding-left': lPadding, 'top': top}" color="secondary"
              dark
              height="42px">

      <v-toolbar-title class="ml-0 mr-3" v-if="title">{{title}}</v-toolbar-title>

      <template v-if="!modalMode">

         <v-tooltip bottom v-if="showBack">
            <v-btn @click="onBackClick" icon slot="activator" small>
               <v-icon small>fas fa-arrow-left</v-icon>
            </v-btn>
            <span v-t="'appMsg.back'"></span>
         </v-tooltip>

         <v-tooltip bottom v-if="showNavigation">
            <v-btn @click="onCommandClick('previous')" icon slot="activator" small>
               <v-icon small>fas fa-chevron-left</v-icon>
            </v-btn>
            <span v-t="'appMsg.previous'"></span>
         </v-tooltip>

         <v-tooltip bottom v-if="showNavigation">
            <v-btn @click="onCommandClick('next')" icon slot="activator" small>
               <v-icon small>fas fa-chevron-right</v-icon>
            </v-btn>
            <span v-t="'appMsg.next'"></span>
         </v-tooltip>


      </template>


      <v-divider class="mx-2" inset v-if="showBack" vertical></v-divider>

<!--      <v-tooltip bottom>-->
         <v-btn :loading="saving" @click="onSaveClick" color="accent" small round>
            <v-icon small>fas fa-check</v-icon> <span v-t="'appMsg.save'" class="ml-2"></span>
         </v-btn>
<!--         <span v-t="'appMsg.save'"></span>-->
<!--      </v-tooltip>-->

      <!---------------------------->

      <v-spacer/>
      <template v-if="showBlock && !newState && !modalMode">
         <v-toolbar-items style="padding-top: 6px; padding-right: 10px">
            <v-switch :label="$t('appMsg.block')" :readonly="Boolean(blocked && !$uCan({op: 'UB'}))" :value="blocked" @change="(v) => onCommandClick(v ? 'block' : 'unblock')"
                      color="error"
                      hide-details></v-switch>
         </v-toolbar-items>
         <v-divider class="ma-2" inset vertical></v-divider>
      </template>

      <template v-if="!newState && !modalMode && $uCan({op: 'D'}) && showDelete">
         <v-tooltip bottom>
            <v-btn @click="onCommandClick('delete')" icon slot="activator" small>
               <v-icon small>far fa-trash-alt</v-icon>
            </v-btn>
            <span v-t="'appMsg.delete'"></span>
         </v-tooltip>
         <v-divider class="ma-2" inset vertical></v-divider>
      </template>

      <v-tooltip bottom>
         <v-btn @click="onCommandClick('favorite')" icon slot="activator" small v-if="canFavorite">
            <v-icon small>far fa-star</v-icon>
         </v-btn>
         <span v-t="'appMsg.addQuickAccess'"></span>
      </v-tooltip>

      <v-tooltip bottom>
         <v-btn @click="onCommandClick('print')" icon slot="activator" small v-if="print && !newState">
            <v-icon class="flaticon-printer" small></v-icon>
         </v-btn>
         <span v-t="'appMsg.print'"></span>
      </v-tooltip>

      <v-tooltip bottom>
         <v-btn @click="onCommandClick('share')" icon slot="activator" small v-if="!newState">
            <v-icon small>fas fa-share-alt</v-icon>
         </v-btn>
         <span v-t="'appMsg.share'"></span>
      </v-tooltip>

      <v-tooltip bottom>
         <v-btn @click="onCommandClick('restore')" icon slot="activator" small>
            <v-icon small>fas fa-sync-alt</v-icon>
         </v-btn>
         <span v-t="'appMsg.restore'"></span>
      </v-tooltip>

      <v-tooltip bottom v-if="modalMode">
         <v-btn @click="$emit('onCommand', 'close')" icon slot="activator" small>
            <v-icon size="20">far fa-times-circle</v-icon>
         </v-btn>
         <span v-t="'appMsg.close'"></span>
      </v-tooltip>

   </v-toolbar>

</template>

<script>
   export default {
      name: 'crud-toolbar',

      props: {
         title: {
            type: String,
            required: false
         },
         modalMode: {
            type: Boolean,
            required: false,
            default: false
         },
         newState: {
            type: Boolean,
            required: false,
            default: false
         },
         showBack: {
            type: Boolean,
            required: false,
            default: true
         },
         showNavigation: {
            type: Boolean,
            required: false,
            default: false
         },
         showBlock: {
            type: Boolean,
            required: false,
            default: false
         },
         showDelete: {
            type: Boolean,
            required: false,
            default: true
         },
         isBlocked: {
            required: false,
            default: false
         },
         print: {
            type: Boolean,
            required: false,
            default: false
         }

      },

      data: () => ({
         saving: false,
         blocked: 0,
         defaultTop: 64
      }),

      computed: {
         lPadding () {
            return `${260 * (+(!this.modalMode)) * (+this.$store.state.app.navDrawer)}px`;
         },
         top () {
            if (!this.modalMode) {
               let appTb = (this.$vuetify.breakpoint === 'xs') ? 56 : this.defaultTop;
               //document.getElementsByClassName('app--toolbar')[0].clientHeight || t;

               return `${appTb}px`;
            }
            return '0px';
         },
         canFavorite () {
            return (this.$config && this.$config.favorites);
         }

      },

      methods: {
         onCommandClick (command) {
            // console.log(command);
            this.$emit('onCommand', command);
         },
         onBackClick () {
            this.$emit('onCommand', 'back');
         },
         onSaveClick () {
            this.saving = true;
            this.$emit('onCommand', 'save');
            setTimeout(() => this.saving = false, 1000);
         },
         resized () {
            this.defaultTop = (document.getElementsByClassName('app--toolbar')[0].clientHeight || 64);
         }
      },

      mounted () {
         // console.log('toolbar newstate', this.newState);
         this.$nextTick(() => {
            this.$forceUpdate(); //to correctly update DOM padding left after mounted
         });

         window.getApp.$on('APP_MAIN_CONTENT_RESIZE', this.resized);

         // console.log(this.isBlocked, 'isBlocked');
         this.blocked = Boolean(this.isBlocked);

         //To make sticked css class work as it is a fixed app toolbar
         /*this.oldParent = this.$el.parentElement;
         let pw = document.getElementsByClassName('page-wrapper')[0];
         pw.insertBefore(this.$el, pw.firstChild);*/

      },

      beforeDestroy () {
         window.getApp.$off('APP_MAIN_CONTENT_RESIZE', this.resized);
         // this.oldParent.insertBefore(this.$el, this.oldParent.firstChild);
      }


   };
</script>

<style scoped>
   .sticked {
      position: -webkit-sticky;
      position: sticky;
      top: 64px;

   }

</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/crudPage/crudToolbar.vue